export interface ISalesCategory {
  readonly salesCategoryId?: number;
  readonly guid?: string;
  readonly number?: number;
  readonly name: string;
  readonly description?: string;
  readonly code: string;
  /** Hex color for charts (e.g. #0ea5e9). Used in dashboard pie and reports. */
  readonly color?: string;
  readonly isArchived?: boolean;
  readonly createdAt?: Date;
  readonly updatedAt?: Date;
  readonly archivedAt?: Date;
}

export interface ISalesCategoryData {
  salesCategoryId?: number;
  guid?: string;
  number?: number;
  name: string;
  description?: string;
  code: string;
  color?: string;
  isArchived?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
  archivedAt?: Date;
}

export class SalesCategory implements ISalesCategory {
  readonly salesCategoryId?: number;
  readonly guid?: string;
  readonly number?: number;
  readonly name: string;
  readonly description?: string;
  readonly code: string;
  readonly color?: string;
  readonly isArchived?: boolean;
  readonly createdAt?: Date;
  readonly updatedAt?: Date;
  readonly archivedAt?: Date;

  constructor(data: ISalesCategoryData) {
    this.salesCategoryId = data.salesCategoryId;
    this.guid = data.guid;
    this.number = data.number;
    this.name = data.name;
    this.description = data.description;
    this.code = data.code;
    this.color = data.color;
    this.isArchived = data.isArchived ?? false;
    this.createdAt = data.createdAt || new Date();
    this.updatedAt = data.updatedAt || new Date();
    this.archivedAt = data.archivedAt;
  }

  toJSON(): ISalesCategory {
    return {
      salesCategoryId: this.salesCategoryId,
      guid: this.guid,
      number: this.number,
      name: this.name,
      description: this.description,
      code: this.code,
      color: this.color,
      isArchived: this.isArchived,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
      archivedAt: this.archivedAt,
    };
  }

  static fromJSON(data: Record<string, unknown>): SalesCategory {
    if (!data.name) throw new Error("SalesCategory.fromJSON: name is missing.");
    if (!data.code) throw new Error("SalesCategory.fromJSON: code is missing.");

    // Helper function to convert Firestore timestamps to Date objects
    const convertTimestamp = (timestamp: any): Date | undefined => {
      if (!timestamp) return undefined;
      // Check if it's a Firestore Timestamp object
      if (timestamp && typeof timestamp.toDate === 'function') {
        return timestamp.toDate();
      }
      // Check if it's already a Date object
      if (timestamp instanceof Date) {
        return timestamp;
      }
      // Try to parse as string/number
      return new Date(timestamp);
    };

    return new SalesCategory({
      salesCategoryId: data.salesCategoryId as number | undefined,
      guid: data.guid as string | undefined,
      number: data.number as number | undefined,
      name: data.name as string,
      description: data.description as string | undefined,
      code: data.code as string,
      color: data.color as string | undefined,
      isArchived: data.isArchived as boolean | undefined,
      createdAt: convertTimestamp(data.createdAt),
      updatedAt: convertTimestamp(data.updatedAt),
      archivedAt: convertTimestamp(data.archivedAt),
    });
  }
} 